// Statistics

;(function ($) {
  /**
   * Statistics instance
   */

  function StatisticsInstance($rowElement) {
    this.id = $rowElement.attr('data-id');

    this.url = $rowElement.attr('data-url');

    this.$rowElement = $rowElement;
    this.$statsChart = $rowElement.find('.statistics-chart__render');

    this.chartClone = $rowElement.parent().find('.statistics-chart__empty.hide.statistics-chart__empty--clone[data-id="' + this.id + '"]').clone().removeClass('statistics-chart__empty--clone').removeClass('hide')[0].outerHTML;

    this.refreshDataTimeout = null;
    this.ajax = null;

    this.registerEvents();
    this.refreshDataFinal();
  }

  StatisticsInstance.prototype.registerEvents = function() {
    $(window).unbind('FORM_INIT.statistics').bind('FORM_INIT.statistics', debounce(function () {
      this.reRenderChart();
    }.bind(this), 50));
  };

  StatisticsInstance.prototype.refreshData = function() {
    if (this.refreshDataTimeout !== null) {
      clearTimeout(this.refreshDataTimeout);
      this.refreshDataTimeout = null;
    }

    if (this.ajax !== null) {
      this.ajax.abort();
      this.ajax = null;
    }

    this.refreshDataTimeout = setTimeout(this.refreshDataFinal.bind(this), 50);
  };

  StatisticsInstance.prototype.refreshDataFinal = function() {
    this.refreshDataTimeout = null;

    if (this.ajax !== null) {
      this.ajax.abort();
      this.ajax = null;
    }

    this.ajax = $.ajax({
      type: 'POST',
      dataType: 'json',
      cache: false,
      data: this.getDataArr(),
      url: this.url,
      success: function (data) {
        this.chartData = data;

        this.reRenderChart();
      }.bind(this),
      error: function () {
        this.chartData = [];

        this.reRenderChart();
      }.bind(this)
    });
  };

  StatisticsInstance.prototype.getDataArr = function() {
    return this.$rowElement.parents('form').serialize();
  };

  StatisticsInstance.prototype.reRenderChart = function() {
    if (typeof this.chartData !== 'undefined') {
      if (typeof this.chartData[0] === "undefined" || typeof this.chartData[0][0] === "undefined") {
        this.$statsChart.html(this.chartClone);
      }
      else {
        this.$statsChart.html('');

        this.chart = new Morris.Area({
          element: 'chart-' + this.id,
          data: (typeof this.chartData[0] !== 'undefined' ? this.chartData[0] :  []),
          parseTime: false,
          xkey: 'dates',
          ykeys: (typeof this.chartData[1] !== 'undefined' ? this.chartData[1] : []),
          labels: (typeof this.chartData[1] !== 'undefined' ? this.chartData[1] : []),
          lineColors: (typeof window.lineColors !== 'undefined' ? window.lineColors : ["#1CB6EA", "#1e97bf"]),
          lineWidth: 2,
          pointFillColors: ['#ffffff', '#ffffff', '#ffffff'],
          pointStrokeColors: ['#DDDDDD', '#DDDDDD', '#DDDDDD'],
          hideHover: 'auto',
          pointSize: 0,
          fillOpacity: 0.45,
          ymax: 'auto 5'
        });
      }
    }
  };

  StatisticsInstance.prototype.resize = function() {
    this.reRenderChart();
  };

  /**
   * Statistics component
   */
  function Statistics() {
    this.instances = [];

    $(window).resize(function () {
      if (this.instances.length > 0) {
        for (var i = 0, len = this.instances.length; i < len; i++) {
          this.instances[i].resize();
        }
      }
    }.bind(this));
  }

  Statistics.prototype.add = function(element) {
    var id = $(element).attr('data-id');
    var exists = false;

    if (this.instances.length > 0) {
      for (var instance in this.instances) {
        if (this.instances[instance].id == id) {
          exists = true;
        }
      }
    }

    if (!exists) {
      this.instances.push(
        new StatisticsInstance(
          element
        )
      );
    }
  };

  /**
   * Linechart Instance
   */
  function LinechartInstance($rowElement) {
    Chart.defaults.global.tooltips.titleSpacing = 4;
    Chart.defaults.global.tooltips.xPadding = 10;
    Chart.defaults.global.tooltips.yPadding = 8;
    Chart.defaults.global.tooltips.bodySpacing = 5;

    this.id = $rowElement.attr('data-id');
    this.labels = $rowElement.attr('data-labels') === 'true' ? true : false;
    this.variant = $rowElement.attr('data-variant');
    this.scales_type = $rowElement.attr('data-scales-type');
    this.render_it = $rowElement.attr('data-render-it');
    this.url = $rowElement.attr('data-url');
    this.config = {
      type: ((typeof this.variant != 'undefined' && this.variant !== false) ? this.variant : 'line'),
      data: {

      },
      options: {
        legend: {
          display: this.labels
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            drawOnChartArea: false,
            scaleLabel: {
              display: false,
              labelString: 'Dates'
            },
            type: ((typeof this.scales_type != 'undefined' && this.scales_type !== false)) ? this.scales : "time",
            time: {
              unit: 'day',
              displayFormats: {
                day: 'DD-MM-YYYY'
              },
              tooltipFormat: 'DD-MM-YYYY'
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'value'
            }
            /*,
            ticks: {
              beginAtZero: true,
              callback: function(value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }*/
          }]
        }
      }
    };

    this.$rowElement = $rowElement;
    this.$form = this.$rowElement.parents('form');

    this.refreshDataTimeout = null;
    this.ajax = null;

    if (typeof this.render_it != 'undefined' && this.render_it === 'true') {
      this.renderChart();
    }
    else {
      this.registerEvents();
    }
  }

  LinechartInstance.prototype.registerEvents = function() {
    $(window).unbind('FORM_INIT.linecharts').bind('FORM_INIT.linecharts', debounce(function () {
      this.renderChart();
    }.bind(this), 50));
  };

  LinechartInstance.prototype.renderChart = function() {
    Chart.defaults.global.defaultFontColor = '#383838';
    Chart.defaults.global.defaultFontFamily = 'Open sans';

    $.ajax({
      type: 'POST',
      cache: false,
      data: this.getDataArr(),
      dataType: 'json',
      url: this.url,
      success: function (data) {
        this.config.data.labels = data.labels;
        this.config.data.datasets = data.datasets;
        this.config.options.scales.xAxes[0].scaleLabel.labelString = data.xlabel;
        this.config.options.scales.yAxes[0].scaleLabel.labelString = data.ylabel;

        if (typeof this.chart == 'undefined') {
          this.ctx = document.getElementById(this.id).getContext('2d');
          this.chart = new Chart(this.ctx, this.config);
        }
        else {
          this.chart.update(this.config);
        }
      }.bind(this),
      error: function () {
      }.bind(this)
    });
  };

  LinechartInstance.prototype.getDataArr = function() {
    return this.$form.serialize();
  };

  /**
   * Linecharts component
   */
  function Linecharts() {
    this.instances = [];
  }

  Linecharts.prototype.add = function(element) {
    var id = $(element).attr('data-id');
    var exists = false;

    if (this.instances.length > 0) {
      for (var instance in this.instances) {
        if (this.instances[instance].id == id) {
          exists = true;
        }
      }
    }

    if (!exists) {
      this.instances.push(
        new LinechartInstance(
          element
        )
      );
    }
  };

  /**
   * Donutchart Instance
   */
  function DonutchartInstance($rowElement) {
    var self = this;
    this.id = $rowElement.attr('data-id');

    this.url = $rowElement.attr('data-url');
    this.interval = $rowElement.attr('data-interval');
    this.variant = $rowElement.attr('data-variant');
    this.icons = $rowElement.attr('data-icons') === 'true';
    this.labels = $rowElement.attr('data-labels') === 'true';
    this.render_it = $rowElement.attr('data-render-it');

    this.config = {
      type: ((typeof this.variant !== typeof undefined && this.variant !== false) ? this.variant : 'doughnut'),
      data: {
        datasets: [{
          data: [3, 6, 14],
          backgroundColor: ['#ff9f40', '#36a2eb', '#4bc0c0']
        }],
        labels: [
          'mobile',
          'tablet',
          'desktop'
        ]
      },
      options: {
        responsive: true,
        legendCallback: function(chart) {
          if (self.labels) {
            var text = [];
            text.push('<ul>');
            for (var i=0; i<chart.data.datasets[0].data.length; i++) {
              text.push('<li class="doughnutchart-legend" >');

              if (self.icons) {
                text.push('<i class="fa fa-'+chart.data.labels[i]+'" aria-hidden="true" style="color:' + chart.data.datasets[0].backgroundColor[i] + '"></i>');
              }
              else {
                text.push('<span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '">' + chart.data.labels[i] + '</span>');
              }
              text.push('</li>');
            }
            text.push('</ul>');
            return text.join('');
          }
          else {
            return '';
          }
        },
        legend: false,
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    };

    this.$rowElement = $rowElement;
    this.$form = this.$rowElement.parents('form');
    this.$realtime = this.$rowElement.parents('.realtime-wrapper');

    this.refreshDataTimeout = null;
    this.ajax = null;

    if (typeof this.render_it != 'undefined' && this.render_it === 'true') {
      this.renderChart();
    }
    else {
      this.registerEvents();
    }

    if (typeof this.interval !== 'undefined') {
      var int = parseInt(this.interval);
      this.intervalTimer = setInterval(this.updateChart.bind(this), int);
    }
  }

  DonutchartInstance.prototype.registerEvents = function() {
    $(window).unbind('FORM_INIT.donutcharts').bind('FORM_INIT.donutcharts', debounce(function () {
      this.renderChart();
    }.bind(this), 50));
  };

  DonutchartInstance.prototype.renderChart = function() {
    $.ajax({
      type: 'POST',
      cache: false,
      data: this.getDataArr(),
      dataType: 'json',
      url: this.url,
      success: function (data) {
        var data_len = data.data.length;

        if (data_len == 0 || data.data.reduce(function(acc, val) { return acc + val; }) == 0) {
          data.data = [1];
          data.labels = ['No data'];
          data.backgroundColors = ['#eee'];
          this.config.options.tooltips = {enabled: false};
        }
        else {
          this.config.options.tooltips = {enabled: true};
        }

        this.config.data.labels = data.labels;
        this.config.data.datasets[0].data = data.data;
        this.config.data.datasets[0].backgroundColor = data.backgroundColors;

        if (this.$realtime.length) {
          $('.number', this.$realtime).html(data.total);
        }

        var canvas = document.getElementById(this.id);

        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        if (typeof this.chart == 'undefined') {
          this.ctx = canvas.getContext('2d');
          this.chart = new Chart(this.ctx, this.config);
        }
        else {
          this.chart.destroy();
          this.ctx = canvas.getContext('2d');
          this.chart = new Chart(this.ctx, this.config);
        }

        document.getElementById('chart-legends-'+this.id).innerHTML = this.chart.generateLegend();
        var self = this;

        $('#chart-legends-'+this.id + ' li').on('click', function() {
          var index = $(this).index();
          var hidden = self.chart.getDatasetMeta(0).data[index].hidden;

          self.chart.getDatasetMeta(0).data[index].hidden = !hidden;

          if (hidden) {
            $(this).removeClass('doughnutchart-legend--disabled');
          }
          else {
            $(this).addClass('doughnutchart-legend--disabled');
          }
          self.chart.update();
        });
      }.bind(this),
      error: function () {
      }.bind(this)
    });
  };

  DonutchartInstance.prototype.getDataArr = function() {
    return this.$form.serialize();
  };

  DonutchartInstance.prototype.updateChart = function() {
    if (typeof this.chart !== 'undefined') {
      $.ajax({
        type: 'POST',
        cache: false,
        data: this.getDataArr(),
        dataType: 'json',
        url: this.url,
        success: function (data) {
          this.chart.data.datasets[0].data = data.data;

          if (this.$realtime.length) {
            $('.number', this.$realtime).html(data.total);
          }

          this.chart.update();
        }.bind(this),
        error: function () {
        }.bind(this)
      });
    }
  };

  /**
   * Donutcharts component
   */
  function Donutcharts() {
    this.instances = [];
  }

  Donutcharts.prototype.add = function(element) {
    var id = $(element).attr('data-id');
    var exists = false;

    if (this.instances.length > 0) {
      for (var instance in this.instances) {
        if (this.instances[instance].id == id) {
          exists = true;
        }
      }
    }

    if (!exists) {
      this.instances.push(
        new DonutchartInstance(
          element
        )
      );
    }
  };

  /**
   * Popup component
   */
  function Popup() {
    this.callback = null;
    this.waitingForLoadTimeout = null;
  }

  Popup.prototype.open = function(src, callback, className) {
    callback = callback || null;
    className = className || '';

    if (callback) {
      this.callback = callback;
    }

    var extClass = '';

    var $popup = $([
      '<div class="popup popup--iframe popup--loading ' + className + '">',
        '<span class="popup__close"></span>',
        '<div class="popup__content">',
        '</div>',
      '</div>',
    ].join(''));

    if (src.substr(0, 4) == 'http') {
      extClass = ' popup__iframe--external';
    }

    $iframe = $('<iframe class="popup__iframe' + extClass + '" src="' + src + '/overlay:1/" scrolling="auto" frameborder="0"></iframe>');

    this.waitingForLoadTimeout = setTimeout(this.loaded.bind(this, $iframe), 2000);

    $popup.find('.popup__content').append($iframe);
    $('body').addClass('page--popup-active');

    $popup.find('.popup__close').unbind('click').bind('click', function (e) {
      this.element.removeClass('popup--active');
      $('body').removeClass('page--popup-active');

      if (this.scope.callback) {
        this.scope.callback();

        this.scope.callback = null;
      }

      setTimeout(function() {
        this.remove();
      }.bind(this.element), 500);

      return false;
    }.bind({scope: this, element: $popup}));

    $(document.body).append($popup);

    setTimeout(function() {
      $popup.addClass('popup--active');
    }, 10);
  };

  Popup.prototype.close = function($popup, value) {
    $popup = $popup instanceof jQuery ? $popup : $($popup);

    $popup.removeClass('popup--active');
    $('body').removeClass('page--popup-active');

    if (this.callback) {
      this.callback(value);

      this.callback = null;
    }

    setTimeout(function() {
      this.remove();
    }.bind($popup), 500);
  };

  Popup.prototype.closeParent = function($child, value) {
    $child = $child instanceof jQuery ? $child : $($child);

    if (this.callback) {
      this.callback(value);

      this.callback = null;
    }

    var $popup = $child.parents('.popup');

    $popup.removeClass('popup--active');
    $('body').removeClass('page--popup-active');

    setTimeout(function() {
      this.remove();
    }.bind($popup), 500);
  };

  Popup.prototype.loaded = function(iframe) {
    if (this.waitingForLoadTimeout !== null) {
      clearTimeout(this.waitingForLoadTimeout);
      this.waitingForLoadTimeout = null;
    }

    $(iframe).parents('.popup').removeClass('popup--loading');
  };

  window.statistics = new Statistics();
  window.linecharts = new Linecharts();
  window.donutcharts = new Donutcharts();
  window.popup = new Popup();

  function PositionerInstance(id, background, fields, callback) {
    this.id = id;
    this.background = background;
    this.fields = fields;
    this.callback = callback || null;

    this.$container = null;
    this.$modal = null;

    this.$box_x = null;
    this.$box_y = null;
    this.$box_w = null;
    this.$box_h = null;
    this.$box_use_size_for_all = null;

    this.activeField = null;

    this.start = 0;

    this.originalWidth = 0;
    this.originalHeight = 0;

    this.registerElements();

    this.show();
  }

  PositionerInstance.prototype.show = function() {
    this.start = new Date().getTime();

    this.renderBackground(function () {
      this.renderFields();

      this.showModal();
    }.bind(this));
  };

  PositionerInstance.prototype.showModal = function() {
    this.$modal.addClass('popup--active');

    this.$modal.find('.popup__close').unbind('click').bind('click', function (e) {
      $(this).parents('.popup').removeClass('popup--active');
      $('body').removeClass('page--popup-active');
    });
  };

  PositionerInstance.prototype.registerElements = function() {
    this.$container = $('#positioner-container-' + this.id);
    this.$modal = this.$container.parents('.popup');

    if (!this.$modal.hasClass('moved')) {
      this.$modal.appendTo(document.body);
      this.$modal.addClass('moved');
    }

    this.$box_x = this.$modal.find('.box-x input');
    this.$box_y = this.$modal.find('.box-y input');
    this.$box_w = this.$modal.find('.box-w input');
    this.$box_h = this.$modal.find('.box-h input');
    this.$box_use_size_for_all = this.$modal.find('.box-use-size-for-all input');
  };

  PositionerInstance.prototype.resizeFields = function () {
    var
      imgWidth = $(this.img).width(),
      imgHeight = $(this.img).height();

    if (this.$box_use_size_for_all.is(':checked') && this.activeField !== null && typeof this.fields[this.activeField] !== 'undefined') {
      for (var field2 in this.fields) {
        if (field2 != this.activeField) {
          this.fields[field2].w = this.fields[this.activeField].w;
          this.fields[field2].h = this.fields[this.activeField].h;
        }
      }
    }

    for (var field in this.fields) {
      var
        fieldItem = this.fields[field],
        fieldElement = this.$container.find('.field[data-index="' + field + '"]')[0],
        extraStyle = '';

      if (typeof fieldItem.bg !== 'undefined' && fieldItem.bg !== null) {
        extraStyle += 'background-image: url(' + fieldItem.bg + ');';
        extraStyle += 'background-repeat: no-repeat;';
        extraStyle += 'background-position: center center;';
        extraStyle += 'background-size: contain;';
      }

      var
        x = fieldItem.x * this.scale,
        y = fieldItem.y * this.scale,
        w = fieldItem.w * this.scale,
        h = fieldItem.h * this.scale;

      x = Math.max(0, x);
      y = Math.max(0, y);
      x = Math.min((imgWidth - w), x);
      y = Math.min((imgHeight - h), y);

      if (this.activeField !== null && field == this.activeField) {
        this.$box_x.val(Math.ceil(x / this.scale));
        this.$box_y.val(Math.ceil(y / this.scale));
        this.$box_w.val(Math.ceil(w / this.scale));
        this.$box_h.val(Math.ceil(h / this.scale));

        extraStyle += 'z-index: 9999;';
      }

      fieldElement.style.cssText = 'z-index: 999; left: ' + x + 'px; top: ' + y + 'px; width: ' + w + 'px; height: ' + h + 'px; line-height: ' + h + 'px;' + extraStyle;
    }
  };

  PositionerInstance.prototype.registerEvents = function() {
    $(window).unbind('resize.positioner').bind('resize.positioner', function () {
      // this.scale = Math.min(1, ($('.popup__content').width() / this.originalWidth));
      this.scale = 1;

			this.resizeFields();
		}.bind(this));

		this.$box_x.unbind('keypress keyup keydown').bind('keypress keyup keydown', this, function (e) {
			if (e.data.activeField !== null) {
				var
					$this = $(this),
					val = parseInt($this.val(), 10);

				if (!isNaN(val)) {
          e.data.fields[e.data.activeField].x = val;

          e.data.resizeFields();
				}
			}
		});

		this.$box_y.unbind('keypress keyup keydown').bind('keypress keyup keydown', this, function (e) {
			if (e.data.activeField !== null) {
				var
					$this = $(this),
					val = parseInt($this.val(), 10);

				if (!isNaN(val)) {
          e.data.fields[e.data.activeField].y = val;

          e.data.resizeFields();
				}
			}
		});

		this.$box_w.unbind('keypress keyup keydown').bind('keypress keyup keydown', this, function (e) {
			if (e.data.activeField !== null) {
				var
					$this = $(this),
					val = parseInt($this.val(), 10);

				if (!isNaN(val)) {
          e.data.fields[e.data.activeField].w = val;

          e.data.resizeFields();
				}
			}
		});

		this.$box_h.unbind('keypress keyup keydown').bind('keypress keyup keydown', this, function (e) {
			if (e.data.activeField !== null) {
				var
					$this = $(this),
					val = parseInt($this.val(), 10);

				if (!isNaN(val)) {
          e.data.fields[e.data.activeField].h = val;

          e.data.resizeFields();
				}
			}
    });

    this.$box_use_size_for_all.unbind('change').bind('change', this, function (e) {
      e.data.resizeFields();
    });

		$(document).unbind('keydown.builder').bind('keydown.builder', this, function (e) {

			if ([38, 37, 40, 39].indexOf(e.which) !== -1 && e.data.activeField !== null) {
				// 38: up
				// 37: left
				// 40: down
				// 39: right
        var currentValue;

				switch (e.which) {
					case 38:
						currentValue = parseInt(e.data.$box_y.val(), 10);

						e.data.$box_y.val((currentValue - 1)).keyup();
						break;

					case 37:
						currentValue = parseInt(e.data.$box_x.val(), 10);

						e.data.$box_x.val((currentValue - 1)).keyup();
						break;

					case 40:
						currentValue = parseInt(e.data.$box_y.val(), 10);

						e.data.$box_y.val((currentValue + 1)).keyup();
						break;

					case 39:
						currentValue = parseInt(e.data.$box_x.val(), 10);

						e.data.$box_x.val((currentValue + 1)).keyup();
						break;
				}

				e.stopPropagation();
				e.preventDefault();
			}
		});

		this.$modal.find('.save').unbind('click').bind('click', this, function (e) {
      e.preventDefault();

      if (typeof this.callback !== null) {
        this.callback.apply(this, [this.fields, function () {
          this.$modal.removeClass('popup--active');
          $('body').removeClass('page--popup-active');
        }.bind(this)]);
      }
    }.bind(this) );

		this.$container.find('.field').unbind('mousedown touchstart').bind('mousedown touchstart', this, function (e) {
			e.preventDefault();
      e.stopPropagation();

      if (!$('.sidebar').hasClass('sidebar--has-toggled')) {
        $('.sidebar').addClass('sidebar--active');
      }

			var
				$this = $(this),
				touch = (typeof e.pageX != 'undefined' ? e : e.originalEvent.touches[0]),
				startX = touch.pageX,
				startY = touch.pageY,
				PoSx = parseInt(this.style.left, 10),
				PoSy = parseInt(this.style.top, 10),
				width = parseInt(this.style.width, 10),
				height = parseInt(this.style.height, 10);

      e.data.activeField = $this.data('index');

      e.data.resizeFields();

			$this.data('PoSx', PoSx);
			$this.data('PoSy', PoSy);

			$(document).unbind('mousemove mouseup touchmove touchend').bind('mousemove touchmove', e.data, function (e) {
				e.preventDefault();
				e.stopPropagation();

				var
					touch = (typeof e.pageX != 'undefined' ? e : e.originalEvent.touches[0]),
					diffX = (touch.pageX > startX ? (touch.pageX - startX) : (startX - touch.pageX)),
					diffY = (touch.pageY > startY ? (touch.pageY - startY) : (startY - touch.pageY)),
					x = (touch.pageX > startX ? ($this.data('PoSx') + diffX) : ($this.data('PoSx') - diffX)),
					y = (touch.pageY > startY ? ($this.data('PoSy') + diffY) : ($this.data('PoSy') - diffY));

				x = Math.max(0, x);
				y = Math.max(0, y);
				x = Math.min(($(e.data.img).width() - $this.width()), x);
        y = Math.min(($(e.data.img).height() - $this.height()), y);

				e.data.fields[$this.data('index')].x = x / e.data.scale;
        e.data.fields[$this.data('index')].y = y / e.data.scale;

        e.data.resizeFields();
			}).bind('mouseup touchend', e.data, function (e) {
				e.preventDefault();
				e.stopPropagation();

				$(document).unbind('mousemove mouseup touchmove touchend');
			});
		});

		this.$container.find('.field span').unbind('mousedown touchstart').bind('mousedown touchstart', this, function (e) {
			e.preventDefault();
			e.stopPropagation();

			var
				$this = $(this).parent(),
				touch = (typeof e.pageX != 'undefined' ? e : e.originalEvent.touches[0]),
				startX = touch.pageX,
				startY = touch.pageY,
				width_ = parseInt($this[0].style.width, 10),
				height_ = parseInt($this[0].style.height, 10);

      e.data.activeField = $this.data('index');

      e.data.resizeFields();

			$this.data('width', width_);
			$this.data('height', height_);

			$(document).unbind('mousemove mouseup touchmove touchend').bind('mousemove touchmove', e.data, function (e) {
				e.preventDefault();
				e.stopPropagation();

				var
					touch = (typeof e.pageX != 'undefined' ? e : e.originalEvent.touches[0]),
					diffX = touch.pageX - startX,
					diffY = touch.pageY - startY,
					width = Math.max(25, ($this.data('width') + diffX).toFixed(0)),
					height = Math.max(25, ($this.data('height') + diffY).toFixed(0));

				e.data.fields[$this.data('index')].w = width / e.data.scale;
        e.data.fields[$this.data('index')].h = height / e.data.scale;

        e.data.resizeFields();
			}).bind('mouseup touchend', e.data, function (e) {
				e.preventDefault();
				e.stopPropagation();

				$(document).unbind('mousemove mouseup touchmove touchend');
			});
		});
  };

  PositionerInstance.prototype.renderBackground = function(callback) {
    callback = callback || null;

    var $exists = this.$container.find('img,.canvas');

    if ($exists.length > 0) {
      $exists.remove();

      this.$container.find('.field').remove();
    }

    if ((typeof this.background).toLowerCase() != 'string') {
      this.originalWidth = this.background.width;
      this.originalHeight = this.background.height;

      this.img = $('<div class="canvas" style="width:' + this.background.width + 'px; height:' + this.background.height + 'px; background-color: rgba(255, 255, 255, 0.25);" />')[0];

      this.$container.append(this.img);

      this.$container.css({
        height: this.background.height + 'px'
      });

      setTimeout(function () {
        this.imageOffsetLeft = this.img.offsetLeft;

        this.scale = 1;

        if (callback !== null) {
          callback();
        }
      }.bind(this), 10);
    }
    else {
      this.img = new Image();

      this.img.onload = function () {
        this.originalWidth = this.img.width;
        this.originalHeight = this.img.height;

        this.$container.append(this.img);

        this.$container.css({
          height: this.img.height + 'px'
        });

        setTimeout(function () {
          this.imageOffsetLeft = this.img.offsetLeft;

          this.scale = 1;

          if (callback !== null) {
            callback();
          }
        }.bind(this), 10);
      }.bind(this);

      this.img.src = this.background + '?r=' + new Date().getTime();
    }
  };

  PositionerInstance.prototype.renderFields = function() {
    var fieldsHTML = '';

    if (this.fields.length > 0) {
      var itemUse;

      for (var item in this.fields) {
        itemUse = this.fields[item];

        if (itemUse.w > this.img.width || itemUse.h > this.img.height) {
					itemUse.w = this.img.width;
					itemUse.h = this.img.height;
					itemUse.x = 0;
					itemUse.y = 0;
				}

				if (itemUse.x > (this.img.width - itemUse.w)) {
					itemUse.x = (this.img.width - itemUse.w);
				}

				if (itemUse.y > (this.img.height - itemUse.h)) {
					itemUse.y = (this.img.height - itemUse.h);
				}

				if (itemUse.x < 0) {
					itemUse.x = 0;
				}

				if (itemUse.y < 0) {
					itemUse.y = 0;
				}

        var extraStyle = '';

        if (typeof itemUse.bg !== 'undefined' && itemUse.bg !== null) {
          extraStyle += 'background-image: url(' + itemUse.bg + ');';
          extraStyle += 'background-repeat: no-repeat;';
          extraStyle += 'background-position: center center;';
          extraStyle += 'background-size: contain;';
        }

        fieldsHTML += [
					'<div class="field" data-index="' + item + '" style="left: ' + (itemUse.x * this.scale) + 'px; top: ' + (itemUse.y * this.scale) + 'px; width: ' + (itemUse.w * this.scale) + 'px; height: ' + (itemUse.h * this.scale) + 'px; line-height: ' + (itemUse.h * this.scale) + 'px;' + extraStyle + '">',
						(typeof itemUse.label !== 'undefined' ? '<div class="field__label">' + itemUse.label + '</div>' : ''),
						'<span></span>',
					'</div>'
				].join('');
      }
    }

    this.$container.append(fieldsHTML);

    this.registerEvents();
  };

  /**
   * Positioner component
   */
  function Positioner() {
    this.init();
  }

  Positioner.prototype.init = function() {
    this.instances = [];

    if ($('.button--positioner-toggle').length > 0) {
      $('.button--positioner-toggle').unbind('click').click(function (e) {
        e.preventDefault();

        /* jshint ignore:start */
        var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if (isNaN(r)){u=a=64}else if (isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if (u!=64){t=t+String.fromCharCode(r)}if (a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if (r<128){t+=String.fromCharCode(r)}else if (r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if (r<128){t+=String.fromCharCode(r);n++}else if (r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}};
        /* jshint ignore:end */

        var $this = $(this);
        var $value = $this.siblings('.form-element__input--positioner-value-' + $this.data('positioner'));
        var value = $value.val();
        var image = $this.data('image');
        var fields = [];

        if (image.indexOf('/files/') === -1) {
          image = JSON.parse(Base64.decode(image));
        }

        if (value.length > 0) {
          value = Base64.decode(value);
          fields = JSON.parse(value);
        }

        window.positioner.show(
          $this.attr('data-positioner'),
          image,
          fields,
          function (fields, callback) {
            $value.val(Base64.encode(JSON.stringify(fields)));

            this.$modal.find('.form').addClass('loading');

            window.showSuccessDisabled = true;

            saveForm($value, function () {
              this.$modal.find('.form').removeClass('loading').addClass('saved');

              setTimeout(function () {
                reloadForm($value.parents('.form')[0], false);

                callback();

                setTimeout(function () {
                  this.$modal.find('.form').removeClass('loading saved');
                  this.$modal.removeClass('popup--active');
                }.bind(this), 50);
              }.bind(this), 50);
            }.bind(this));
          }
        );
      });
    }
  };

  /**
   * Show a positioner instance
   *
   * @param {string} id
   *  Unique identifier
   *
   * @param {string} background
   *  Path to background image
   *
   * @param {array} fields
   *  Array of fields that user can place
   */
  Positioner.prototype.show = function(id, background, fields, callback) {
    id = id || '';
    background = background || '';
    fields = fields || [];
    callback = callback || null;

    if (this.instances.length > 0) {
      for (var item in this.instances) {
        if (this.instances[item].id == id) {
          this.instances[item].background = background;
          this.instances[item].fields = fields;

          this.instances[item].show();
          return;
        }
      }
    }

    this.instances.push(
      new PositionerInstance(
        id,
        background,
        fields,
        callback
      )
    );
  };

  $(document).ready(function () {
    window.positioner = new Positioner();
  });
})(jQuery);

function pad(number, length) {
	var str = '' + number;

	while (str.length < length) {
		str = '0' + str;
	}

	return str;
}

function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

var domRememberMapping = {};
var domRememberMappingContainer = null;

var scrollMapping = [];
var navMapping = [];
var caretMapping = {
  'elemId': null,
  'caretAtPosition': null
};

var reloadDueTo = '';

var loading = false;

function getCaretPosition (ctrl) {
	// IE < 9 Support
	if (document.selection) {
		ctrl.focus();
		var range = document.selection.createRange();
		var rangelen = range.text.length;
		range.moveStart ('character', -ctrl.value.length);
    var start = range.text.length - rangelen;

		return {
      'start': start,
      'end': start + rangelen
    };
	}
	// IE >=9 and other browsers
	else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
		return {
      'start': ctrl.selectionStart,
      'end': ctrl.selectionEnd
    };
  }
  else {
		return {
      'start': 0,
      'end': 0
    };
	}
}

function setCaretPosition(ctrl, start, end) {
	// IE >= 9 and other browsers
	if (ctrl.setSelectionRange) {
		ctrl.focus();
		ctrl.setSelectionRange(start, end);
	}
	// IE < 9
	else if (ctrl.createTextRange) {
		var range = ctrl.createTextRange();
		range.collapse(true);
		range.moveEnd('character', end);
		range.moveStart('character', start);
		range.select();
	}
}

window.initForm = function ($container) {
  $container = $container || $('body');

  var $formular = $container.find('.form');

  if ($formular.length > 0) {
    $formular.addClass('init');
    initFormElements($formular);
    initListeners($formular);

    var $pipe = $formular.find('.form-pipe:eq(0)');

    if ($pipe.length > 0) {
      $pipe = $pipe.first();

      var pipeContent = $pipe.text();

      if (pipeContent && pipeContent !== '') {
        window.UI.processAjax({
          actions: JSON.parse(pipeContent)
        }, $formular);

        $pipe.remove();

        $pipe = pipeContent = null;
      }
    }

    if ($('body').hasClass('page--popup') && $formular.find('.section').length > 0 && !$formular.hasClass('form--no-stepguide')) {
      initModalForm($formular);
    }

    setTimeout( function() {
      $formular.removeClass('init');
      $(window).trigger('FORM_INIT');

      $formular.addClass('form--did-init');
    }, 0);

    $formular.unbind('submit').bind('submit', function(e) {
      e.preventDefault();

      var $form = $(this);
      var $formError = $form.find('.form-element--invalid');
      var valid;

      if ($('body').hasClass('page--popup') && $form.find('> .section').length > 1 && !$formular.hasClass('form--no-stepguide')) {
        var $sections = $form.find('> .section').toArray();

        valid = validateForm($form.find('> .section--active'));

        if (valid) {
          if ($sections.indexOf($form.find('> .section--active')[0]) !== ($sections.length - 1)) {
            var $nextSection = $form.find('> .section--active').next();

            $form.find('> .section--active').addClass('section--inactive').removeClass('section--active');
            $nextSection.addClass('section--active');

            $form.css({
              height: $nextSection.outerHeight()
            });

            $form.attr('data-active-section', $form.find('.section').index($nextSection));

            if ($form.siblings('.stepguide').length > 0) {
              var nextStep = $form.parent().find('.stepguide .stepguide__item--current').next();

              $form.parent().find('.stepguide .stepguide__item--current').removeClass('stepguide__item--current').addClass('stepguide__item--visited');
              nextStep.addClass('stepguide__item--current');
            }

            if ($nextSection.index() === $form.find('> .section:last').index()) {
              $form.find('.button--submit').val($form.find('.button--submit').data('original'));
            }

            e.preventDefault();

            return false;
          }
          else {
            window.top.window.popup.closeParent(self.frameElement);
          }
        }
        else {
          e.preventDefault();
          return false;
        }
      } else {
        valid = validateForm($form);
      }

      if (!valid) {
        $(document).trigger('FORM_ERROR', $form);

        $('html, body').animate({
          scrollTop: $('.form-element--invalid').offset().top - 50
        }, 500, 'swing');

        hideSuccess($form);

        if (!$formError.hasClass('message--active')) {
          $formError.addClass('message--active');
        }

        setTimeout( function() {
          $formError.removeClass('message--active');
        }, 5000);
      }
      else {
        $formError.removeClass('message--active');

        if ($form.hasClass('form--ajax')) {
          submitForm($form);
        }
      }

      if ($form.hasClass('form--ajax')) {
        e.preventDefault();
      }

      return ($form.hasClass('form--ajax') ? false : valid);
    });
  }

  if ($container.find('.form-autosave').length > 0) {
    $container.find('.form').trigger('submit');
  }
};

function activeParentTabs($reference) {
  var $tabContent = $reference.parents('.tab-content__item');

  $tabContent.each(function () {
    var $this = $(this);

    $this.parent().parent().find('> .tab-navigation > li[data-id="' + $this.attr('data-id') + '"]').click();
  });
}

function validateForm($form) {
  var valid = true;
  var emailValidation = /^([\w-\+]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

  $form.find('.form-element--validate').each( function() {
    var $group = $(this);
    var $field = $group.find('input.form-element__input--text, input.form-element__input--checkbox, textarea.form-element__input--textarea, select, input.form-element__input--radio');

    if ($field.length  > 0) {
      var nodeName = $field[0].nodeName.toLowerCase();

      if (nodeName == 'textarea' || nodeName == 'select' || $field.hasClass('form-element__input--text')) {
        var val = $field.val();

        if (val !== null && !Array.isArray(val)) {
          val = val.replace(/ /ig, '');
        }
        else if (val !== null && Array.isArray(val)) {
          val = val.join(',');
        }
        else {
          val = '';
        }

        if ($field.parents('.form-element.email').length > 0 && !emailValidation.test(val)) {
          val = '';
        }

        if (val === '') {
          valid = false;
          activeParentTabs($group);
          $group.addClass('form-element--invalid');
        }
        else {
          $group.removeClass('form-element--invalid');
        }
      }
      else if ($field.hasClass('form-element__input--checkbox')) {
        if (!$field.is(':checked')) {
          valid = false;
          activeParentTabs($group);
          $group.addClass('form-element--invalid');
        }
        else {
          $group.removeClass('form-element--invalid');
        }
      }
      else if ($field.hasClass('form-element__input--radio')) {
        if (!$field.is(':checked')) {
          valid = false;
          activeParentTabs($group);
          $group.addClass('form-element--invalid');
        }
        else {
          $group.removeClass('form-element--invalid');
        }
      }
    }
  });

  return valid;
}

function initFormElements($form, disableTabs) {
  disableTabs = disableTabs || false;

  var $tabs = $form.find('.tabs .tab-navigation .tab-navigation__item');

  if ($tabs.length > 0) {
    $tabs.unbind('click').click(function (e) {
      var $thiz = $(this);

      if ($thiz.hasClass('tab-navigation__item--active')) {
        return false;
      }

      $thiz.parent().find('.tab-navigation__item--active').removeClass('tab-navigation__item--active');
      $thiz.addClass('tab-navigation__item--active');

      var $tab_content = $thiz.parent().parent().find('> .tab-content > .tab-content__item--' + $thiz.attr('data-id'));

      $thiz.parent().parent().find('> .tab-content > .tab-content__item--active').removeClass('tab-content__item--active');
      $tab_content.addClass('tab-content__item--active');

      initFormElements(
        $tab_content,
        true
      );

      initListeners(
        $tab_content
      );

      UI.init();

      $thiz.parents('.tabs:first').trigger('tabsChanged');

      return false;
    });
  }

  var $chart = $form.find('.statistics-chart:not(.statistics-chart--init)');

  if ($chart.length > 0) {
    $chart.each(function () {
      $(this).addClass('statistics-chart--init');
      window.statistics.add($(this));
    });
  }

  var $linechart = $form.find('.linecharts-chart:not(.linecharts-chart--init)');

  if ($linechart.length > 0) {
    $linechart.each(function () {
      $(this).addClass('linecharts-chart--init');
      window.linecharts.add($(this));
    });
  }

  var $donutchart = $form.find('.donutcharts-chart:not(.donutcharts-chart--init)');

  if ($donutchart.length > 0) {
    $donutchart.each(function () {
      $(this).addClass('donutcharts-chart--init');
      window.donutcharts.add($(this));
    });
  }

  var $navigation = $form.find('.navigation--element .navigation__link');

  if ($navigation.length > 0) {
    $navigation.unbind('click').click(function (e) {
      e.preventDefault();

      var $thiz = $(this);

      $thiz.parents('.navigation--element').find('input').val($thiz.attr('data-id'));

      reloadForm(this);
    });
  }

  var $sortable = $form.find('.sortable');

  if ($sortable.length > 0) {
    $sortable.each(function () {
      registerSortable($(this));
    });
  }

  var $exclude = $form.find('input[data-exclude]');

  if ($exclude.length > 0) {
    $exclude.each(function () {
      var $thiz = $(this);

      $thiz
        .unbind('keypress.exclude keyup.exclude keydown.exclude')
        .bind('keypress.exclude keyup.exclude keydown.exclude', debounce(function () {
          var
            _$thiz = $(this),
            val = _$thiz.val(),
            original_val = val + '',
            exclude = _$thiz.attr('data-exclude');

          if (exclude !== null && exclude !== '') {
            exclude = exclude.split('|BR|');

            for (var exclude_key in exclude) {
              if (exclude.hasOwnProperty(exclude_key)) {
                val = val.replace(new RegExp(escapeRegExp(exclude[exclude_key]), "ig"), '');
              }
            }

            if (val.length !== original_val.length) {
              _$thiz.val(val);
            }
          }
        }, 125)).trigger('keypress.exclude');
    });
  }

  var $typeahead = $form.find('.form-element--typeahead');

  if ($typeahead.length > 0) {
    $typeahead.each(function () {
      registerTypeahead($(this));
    });
  }

  var $popupToggles = $form.find('.button--popup');

  if ($popupToggles.length > 0) {
    $popupToggles.unbind('click').bind('click', function() {
      if (!$(this).hasClass('button--disabled')) {
        var popupClassName = $(this).attr('data-popup-class-name');

        if (typeof popupClassName === 'undefined' || popupClassName === null) {
          popupClassName = '';
        }
        console.log('popupClassName:', popupClassName);
        if (typeof window.top !== 'undefined') {
          if (window.self !== window.top && typeof window.top.popupApiService !== 'undefined') {
            window.top.popupApiService.open($(this).attr('href'), function(data) {
              //submitForm($form, true, false);
            });
          } else {
            window.top.popup.open($(this).attr('href'), null, popupClassName);
          }

        } else {
          window.popup.open($(this).attr('href'), null, popupClassName);
        }
      }

      return false;
    });
  }

  var $popupTriggers = $('.popup--trigger');

  if ($popupTriggers.length > 0) {
    $popupTriggers.unbind('click').bind('click', function(e) {
      e.preventDefault();

      window.popup.open($(this).attr('href'));
    });
  }

  var $toolbarMenu = $('.toolbar__menu');

  if ($toolbarMenu.length > 0) {
    $toolbarMenu.each(function () {
      var $this = $(this);

      $('html').click(function() {
        $toolbarMenu.removeClass('toolbar__menu--active');
      });

      $toolbarItem = $this.find('.toolbar__item');
      $toolbarDrop = $this.prev('.toolbar__drop');

      $toolbarItem.each(function() {
        var delay = $(this).index() * 50 + 'ms';

        $(this).css({
          '-webkit-transition-delay': delay,
          '-moz-transition-delay': delay,
          '-o-transition-delay': delay,
          'transition-delay': delay
        });
      });

      $toolbarDrop.click (function(e){
        e.preventDefault();
        e.stopPropagation();
        $this.toggleClass('toolbar__menu--active');
      });

      $this.click (function(e){
        e.stopPropagation();
      });
    });
  }

  var $buttonLinks = $form.find('.button--link:not(.button--popup)');

  if ($buttonLinks.length > 0) {
    $buttonLinks.unbind('click').bind('click', function(e) {
      var
        $this = $(this),
        href = $this.attr('href');

      if (href.indexOf('#') !== -1 || href.indexOf('.') !== -1) {
        href = href.split('->');

        if (href.length === 2) {
          $(href[0]).trigger(href[1]);
          e.preventDefault();
        }
      }
    });
  }

  var $disabledButtons = $form.find('.button--disabled');

  if ($disabledButtons.length > 0) {
    $disabledButtons.unbind('click.disabled').bind('click.disabled', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      return false;
    });
  }

  var $remember = $form.find('.remember-dom');

  if ($remember.length > 0) {
    $remember.each(function () {
      var instanceName = this.getAttribute('data-instance-name');

      if (typeof domRememberMapping[instanceName] !== 'undefined') {
        $(this).replaceWith(
          domRememberMapping[instanceName]
        );
      }
    });

    domRememberMapping = {};
  }

  var allowedKeys = [13];

  $form.unbind('keypress.keylistener').bind('keypress.keylistener', function (e) {
    if (allowedKeys.indexOf(e.keyCode) !== -1) {
      var keyTriggerMap = {};
      var $keyTriggers = $form.find('button[data-keys]');

      if ($keyTriggers.length > 0) {
        $keyTriggers.each(function () {
          var keys = $(this).attr('data-keys').split(',');

          if (keys.length > 0) {
            for (var key in keys) {
              if (typeof keyTriggerMap[keys[key]] === 'undefined') {
                keyTriggerMap[keys[key]] = [];
              }

              keyTriggerMap[keys[key]].push(
                this
              );
            }
          }
        });
      }

      switch (e.keyCode) {
        case 13:
          // Enter
          if (typeof keyTriggerMap.enter !== 'undefined' && keyTriggerMap.enter.length > 0) {
            for (var field in keyTriggerMap.enter) {
              $(keyTriggerMap.enter[field]).click();
            }
          }
          break;
      }
    }
  });

  if (!disableTabs) {
    var _navMapping = JSON.parse(JSON.stringify(navMapping));

    if (_navMapping.length > 0) {
      for (var i2 = 0, len2 = _navMapping.length; i2 < len2; i2++) {
        if (_navMapping[i2].index < 0) {
          _navMapping[i2].index = 0;
        }

        $form.find('.tabs:not(.tabs--no-navigation):eq(' + i2 + ') .tab-navigation__item:eq(' + _navMapping[i2].index + ')').click();
      }
    }

    _navMapping = null;
  }

  if (scrollMapping.length > 0) {
    for (var i3 = 0, len3 = scrollMapping.length; i3 < len3; i3++) {
      var $item = $form.find('.remember-scroll[data-instance-name="' + scrollMapping[i3].name + '"]');

      if ($item.length > 0) {
        setTimeout(function () {
          this.item.scrollTop = this.scroll;
        }.bind({
          scroll: scrollMapping[i3].scroll,
          item: $item[0]
        }), 1);
      }
    }
  }

  var $pad = $form.find('.form-element__input--pad');

  if ($pad.length > 0) {
    $pad.each(function () {
      var
        $this = $(this),
        val = $this.val(),
        dataLength = parseInt($this.attr('data-length'), 10);

      if (val.length != dataLength && val !== '') {
        $this.val(pad(val, dataLength));
      }
    });

    $pad.unbind('blur').bind('blur', function () {
      var
        $this = $(this),
        val = $this.val(),
        dataLength = parseInt($this.attr('data-length'), 10);

      if (val.length != dataLength && val !== '') {
        $this.val(pad(val, dataLength));
      }
    });
  }

  var $maxLength = $form.find('.form-element--max-length:not(.form-element--tags)');

  $maxLength.each(function () {
    var
      $thiz = $(this),
      $input = $thiz.find('textarea,input'),
      maxLength = parseInt($input.attr('max-length'), 10),
      val = $input.val() + '';

    $thiz.find('.form-element__max-length span').text((maxLength - val.length));

    $input
    .unbind('keypress.maxLength keyup.maxLength keydown.maxLength')
    .bind('keypress.maxLength keyup.maxLength keydown.maxLength', function () {
      val = $input.val() + '';
      var length = (maxLength - val.length);

      if (length < 0) {
        $input.val(val.substr(0, maxLength));
        val = $input.val();
        length = (maxLength - val.length);
      }

      $thiz.find('.form-element__max-length span').text((maxLength - ($input.val() + '').length));
    });
  });

  var $passwordToggle = $form.find('.form-element--password .form-element__toggle');

  if ($passwordToggle.length > 0) {
    $passwordToggle.each(function () {
      var $thiz = $(this);

      $thiz.find('.form-element__toggle-item').unbind('click').click(function () {
        $thiz.toggleClass('form-element__toggle--active');

        if ($thiz.hasClass('form-element__toggle--active')) {
          $thiz.parent().find('input[type="password"]').attr('type', 'text');
        }
        else {
          $thiz.parent().find('input[type="text"]').attr('type', 'password');
        }
      });
    });
  }

  var $select = $form.find('.form-element--select');

  if ($select.length > 0 && jQuery().select2) {
    $select.each( function() {
      var $this = $(this);
      var $selectInput = $this.find('.form-element__input--select');

      $selectInput.not('.form-element__input--select-icons').select2({
        minimumResultsForSearch: ($this.hasClass('form-element--select-search') ? 1 : -1),
      });

      $selectInput.filter('.form-element__input--select-icons').select2({
        dropdownCssClass: 'select2-dropdown--icons',
        minimumResultsForSearch: ($this.hasClass('form-element--select-search') ? 1 : -1),
        templateResult: function(data) {
          return (data.text.startsWith('fa-') ? '<i class="fa ' + data.text + ' fa-fw"></i>' : data.text);
        },
        templateSelection: function(data) {
          return (data.text.startsWith('fa-') ? '<i class="fa ' + data.text + ' fa-fw"></i>' : data.text);
        },
        escapeMarkup: function(markup) {
          return markup;
        }
      });

      if (typeof $selectInput.attr('data-popup') !== 'undefined' && typeof $selectInput.attr('disabled') === 'undefined') {
        $selectInput.siblings('.select2').find('.select2-selection').unbind('mousedown').unbind('click').bind('click.popup', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          window.popup.open($selectInput.attr('data-popup'), function(value) {
            $selectInput.val(value).trigger('change');
          }.bind(this));

          return false;
        }.bind(this));
      }
    });
  }

  setTimeout( function() {
    if (typeof window.editors !== 'undefined' && window.editors.length > 0) {
      for (var codemirrorEditorCount in window.editors) {
        var codemirrorEditor = window.editors[codemirrorEditorCount];

        if ($('#' + codemirrorEditor.id).is(":visible")) {
          var editor = CodeMirror.fromTextArea(document.getElementById(codemirrorEditor.id), {
            lineNumbers: true,
            lineWrapping: true,
            mode: codemirrorEditor.mode,
            readOnly: codemirrorEditor.readonly
          });

          window.editors[codemirrorEditorCount] = editor;
          window['snippet_editor_' + codemirrorEditor.id] = editor;
        }
      }
    }
  }, 1000);

  var $tags = $form.find('.form-element--tags:not(.init) input[type="text"]');

  if ($tags.length > 0) {
    $tags.each(function() {
      var $thiz = $(this);

      $thiz.parents('.form-element--tags').addClass('init');

      if ($thiz.siblings('.bootstrap-tagsinput').length === 0) {
        var tagsOptions = {};
        var maxLength = $thiz.attr('max-length');

        if (maxLength !== null && typeof maxLength !== 'undefined') {
          tagsOptions.maxChars = parseInt(maxLength, 10);
        }

        $thiz.first().tagsinput(tagsOptions);

        var inputType = $thiz.attr('data-input-type');

        if (inputType !== null && typeof inputType !== 'undefined') {
          $thiz.parent().find('input:first').attr('type', inputType);
        }

        $thiz.siblings('.bootstrap-tagsinput').find('input').bind('paste', function(e) {
          e.preventDefault();
          var arr = e.originalEvent.clipboardData.getData('text').split("\n").sort();
          $inp = $(this).closest('.form-element__controls').children('input');

          for (var i in arr) {
            var text = arr[i].trim();

            if (text.substr(0, 1) == '*') {
              text = text.substr(1).trim();
            }

            $inp.tagsinput('add', text);
          }
        });
      }
    });
  }

  var $sidebar = $form.find('.sidebar');

  if ($sidebar.length > 0) {
    $sidebar.each(function () {
      var $this = $(this);
      var $toggle = $this.find('> .sidebar__toggle');
      var icon = $this.attr('data-sidebar-icon');

      if ($toggle.length === 0) {
        $this.prepend('<div class="sidebar__toggle"><i class="fa fa-' + ((typeof icon !== 'undefined' && icon !== '') ? icon : 'bars') + '"></i></div>');
        $toggle = $this.find('> .sidebar__toggle');
      }

      $toggle.unbind('click').click(function () {
        var $thiz = $(this);
        var $sidebarContainer = $thiz.parents('.sidebar');

        if (!$sidebarContainer.hasClass('sidebar--active')) {
          $sidebarContainer.addClass('sidebar--active');
        }
        else {
          $sidebarContainer.addClass('sidebar--has-toggled').removeClass('sidebar--active');
        }
      });
    });
  }

  var $tableIsSortable = $form.find('.table-container--is-sortable:not(.init)');

	if ($tableIsSortable.length > 0) {
		$tableIsSortable.each(function () {
			var $this = $(this);

			$this.addClass('init');

			$this.find('tbody').sortable({
				appendTo: 'body',
        cursor: 'move',
        helper: function (e, ui) {
          ui.children().each(function() {
            $(this).width($(this).width());
          });

          return ui;
        },
        iframeFix: true,
				placeholder: {
	        element: function(currentItem) {
	          return $(currentItem).clone().attr('style', '')[0];
	        },
	        update: function(container, p) {
	          return;
	        }
		    },
				deactivate: function (event, ui) {
					var newSorting = [];
					var i = 0;

					this.find('.sortable-key').each(function () {
						newSorting.push(this.value);

						i++;
					});

					$(this.attr('data-sortable-target')).val(newSorting.join(','));

					reloadForm(this[0]);
				}.bind($this)
			});
		});
	}

  var $gauge = $form.find('.gauge:not(.init)');

  if ($gauge.length > 0) {
    $gauge.each(function () {
      var $this = $(this),
        dataGaugeCallback = $gauge.attr('data-gauge-callback'),
        dataGaugeChange = $gauge.attr('data-gauge-change');

      if (dataGaugeCallback && dataGaugeChange) {
        var opts = {
          lines: 12, // The number of lines to draw
          angle: 0.12, // The length of each line
          lineWidth: 0.43, // The line thickness
          pointer: {
            length: 1, // The radius of the inner circle
            strokeWidth: 0.035, // The rotation offset
            color: '#000000'
          },
          limitMax: 'true',
          colorStart: '#e0e0e0',
          strokeColor: '#F9F9FB',
          percentColors: [[0, "#e0e0e0"], [1, "#1CB6EA"]]
        };

        var gaugeTimer = null;

        var gauge = new Gauge($this.find('canvas')[0]).setOptions(opts); // create sexy gauge!
        gauge.maxValue = 100; // set max gauge value
        gauge.animationSpeed = 1; // set animation speed (32 is default value)
        //gauge.set(20); // set actual value

        var $change = $('#' + dataGaugeChange);

        setTimeout(function () {
          $change.bind('change.gauge keypress.gauge keydown.gauge keyup.gauge', function (_dataGaugeCallback, _gaugeInstance, _$change) {
            if (gaugeTimer !== null) {
              clearTimeout(gaugeTimer);
              gaugeTimer = null;
            }

            gaugeTimer = setTimeout(function () {
              var val = parseInt(window[_dataGaugeCallback](_$change.val()), 10);

              var text = window.gaugeTranslations.low;

              if (val >= 33) {
                text = window.gaugeTranslations.medium;
              }

              if (val >= 66) {
                text = window.gaugeTranslations.strong;
              }

              $(this).find('.text').html(text);

              _gaugeInstance.set(Math.max(1, val));
            }.bind(this), 100);
          }.bind($this[0], dataGaugeCallback, gauge, $change)).trigger('change.gauge');
        }, 250);
      }
    });
  }

  var $datepicker = $form.find('.form-element__input--date:not([readonly])');

  if ($datepicker.length > 0) {
    var datepickerOptions = {
      format: 'dd-mm-yyyy',
      weekStart: 1,
      language: 'da'
    };

    $datepicker.each(function() {
      var
        $this = $(this),
        start_attr = $this.attr('data-start-date'),
        end_attr = $this.attr('data-end-date'),
        tmpDatepickerOptions = $.extend({}, datepickerOptions);

      if (typeof start_attr !== 'undefined' && start_attr !== false) {
        tmpDatepickerOptions.startDate = new Date(start_attr * 1000);
      }

      if (typeof end_attr !== 'undefined' && end_attr !== false) {
        tmpDatepickerOptions.endDate = new Date(end_attr * 1000);
      }
      else {
        tmpDatepickerOptions.endDate = new Date('2036');
      }

      $this.attr('data-original', $this.val());
      $this.datepicker(tmpDatepickerOptions);

      if (typeof $(this).attr('data-change') !== 'undefined') {
        $this.on('hide', function() {
          var
            $thiz = $(this),
            dataOriginal = $thiz.attr('data-original'),
            onChange = $thiz.attr('data-change');

          if (dataOriginal != $thiz.val()) {
            var onChangeFn = window[onChange];

            if (typeof onChangeFn === "function") {
              onChangeFn();
            }

            $thiz.attr('data-original', $thiz.val());
          }

          onChange = null;
          dataOriginal = null;
        });
      }

      var $addon = $this.parent().find('.form-element__addon');

      if ($addon.length > 0) {
        $addon.unbind('click').click(function () {
          $(this).parent().find('.form-element__input--date').focus();
        });
      }
    });

    datepickerOptions = null;
  }


  var $colorpicker = $form.find('.form-element__input--color');

  if ($colorpicker.length > 0) {
    var favColors = [];

    if (typeof window.$BASE_COLORS !== 'undefined' && window.$BASE_COLORS.length > 0) {
      favColors =  window.$BASE_COLORS;
    }

    $colorpicker.each( function() {
      var $elOpacity = $(this).parents('.form-element--color.form-element__input--no-opacity');

      $(this).minicolors({
        animationSpeed: 0,
        animationEasing: 'none',
        opacity: $elOpacity.length > 0 ? false : true,
        swatches: favColors,
        change: function () {
          if ($(this).val() !== '') {
            if ($(this).minicolors('opacity') < 0.99) {
              $(this).parent().parent().find('input[type="hidden"]').val($(this).minicolors('rgbaString'));
            } else {
              $(this).parent().parent().find('input[type="hidden"]').val($(this).minicolors('value'));
            }
          }
          else {
            $(this).parent().parent().find('input[type="hidden"]').val('');
          }
        }.bind(this)
      });
    });
  }

  var $css_editor = $form.find('.css-editor');

  if ($css_editor.length > 0) {
    $css_editor.each( function() {
      CodeMirror.fromTextArea($(this)[0], {
        lineNumbers: true,
        lineWrapping: true
      });
    });
  }

  var $input_mask = $form.find('.form-element__input--mask');

  if ($input_mask.length > 0) {
    $input_mask.each( function() {
      var $this = $(this);

      $this.mask($this.data('mask'));
    });
  }

  var $number = $form.find('.form-element__input--number');

  if ($number.length > 0) {
    $number.unbind('keydown keyup change').bind('keydown keyup change', function() {
      var $this = $(this);

      $this.val($this.val().replace(/[^0-9]/g, ''));

      if ($this.attr('data-max')) {
        var maxNumber = $this.attr('data-max');

        if (parseInt($this.val()) > maxNumber) {
          $this.val(maxNumber);
        }
      }
    });
  }

  if (typeof grecaptcha !== 'undefined') {
    $form.find('.g-recaptcha').each(function () {
      try {
        grecaptcha.render(this, {
          'sitekey': $(this).attr('data-sitekey')
        });
      } catch (e) {
        console.log(e);
      }
    });
  }

  var $password = $form.find('input[type=password]');

  if ($password.length > 0) {
    $password.attr('readonly', true);

    $password.unbind('focus').bind('focus', function() {
      if ($(this).attr('readonly')) {
        $(this).removeAttr('readonly');
      }
    });
  }

  var $sectionSettings = $form.find('.section > .section__header > .settings');

  if ($sectionSettings.length > 0) {
    $sectionSettings.each(function () {
      var
        $settings = $(this),
        $collapseToggle = $settings.find('.settings__item--collapse-toggle'),
        $tutorial = $settings.find('.settings__item--tutorial'),
        $gear = $settings.find('.settings__item--gear .settings__item-icon'),
        $button = $settings.find('.button');

      if ($tutorial.length > 0) {
        $tutorial.unbind('click').click(function (e) {
          e.preventDefault();

          var
            $this = $(this),
            tutorialUrl = $this.attr('data-tutorial-url');

          if (tutorialUrl && tutorialUrl !== '') {
            window.popup.open(
              tutorialUrl
            );
          }
        });
      }

      if ($button.length > 0) {
        $button.unbind('click').click(function (e) {
          e.preventDefault();

          if ($settings.find('input[type="checkbox"]').is(':checked')) {
            $collapseToggle.removeClass('settings__item--disabled');
          }
          else {
            $collapseToggle.addClass('settings__item--disabled');
          }

          if ($settings.find('select').val() !== '') {
            $tutorial.removeClass('settings__item--disabled');
          }
          else {
            $tutorial.addClass('settings__item--disabled');
          }

          $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            data: $settings.find('input, select').serialize(),
            url: $settings.attr('data-url'),
            success: function (data) {
              if (typeof data.tutorial_url !== 'undefined' && data.tutorial_url !== '') {
                $tutorial.attr('data-tutorial-url', data.tutorial_url);
              }
              else {
                $tutorial.attr('data-tutorial-url', '');
              }

              window.UI.processAjax(data, document.body);

              var $render = $settings.find('.settings__item-render');

              if ($render.hasClass('settings__item-render--active')) {
                $render.removeClass('settings__item-render--active');
              }
            }
          });
        });
      }

      if ($gear.length > 0) {
        $gear.unbind('click').click(function () {
          var
            $this = $(this),
            $render = $this.parent().find('.settings__item-render');

          if ($render.hasClass('settings__item-render--active')) {
            $render.removeClass('settings__item-render--active');
          }
          else {
            $render.addClass('settings__item-render--active');
          }
        });
      }

      if ($collapseToggle.length > 0) {
        $collapseToggle
          .unbind('click')
          .click(function () {
            var
              $this = $(this),
              $section = $this.parents('.section').eq(0),
              $sectionBody = $section.find('> .section__body'),
              offset;

            if (!$section.hasClass('section--transitioning')) {
              if ($section.hasClass('section--collapsed')) {
                // Fold out
                $sectionBody[0].style.cssText = [
                  'height: auto;',
                  'overflow: visible;'
                ].join('');

                offset = $sectionBody[0].offsetWidth;

                var foldOutHeight = $sectionBody[0].offsetHeight;

                $sectionBody[0].style.cssText = 'overflow: hidden;';

                offset = $sectionBody[0].offsetWidth;

                $sectionBody[0].style.height = $sectionBody[0].offsetHeight + 'px';

                offset = $sectionBody[0].offsetWidth;

                $section.addClass('section--transitioning');

                offset = $sectionBody[0].offsetWidth;

                $section.removeClass('section--collapsed');

                $this.find('.settings__item-icon--expanded').addClass('settings__item-icon--active');
                $this.find('.settings__item-icon--collapsed').removeClass('settings__item-icon--active');

                $sectionBody[0].style.cssText = [
                  'opacity: 1;',
                  'height: ' + foldOutHeight + 'px;'
                ].join('');

                setTimeout(function () {
                  $section.removeClass('section--transitioning');
                  $sectionBody[0].style.cssText = '';
                }, 375);

                $.ajax({
                  type: 'POST',
                  dataType: 'json',
                  cache: false,
                  data: {
                    form: {
                      type: 'section-settings-user',
                      referenceId: $settings.parents('.section').attr('data-reference-id'),
                      collapsed: 0
                    }
                  },
                  url: $settings.attr('data-url')
                });
              }
              else {
                // Fold in
                $sectionBody[0].style.height = $sectionBody[0].offsetHeight + 'px';

                $section.addClass('section--transitioning');

                offset = $sectionBody[0].offsetWidth;

                $section.addClass('section--collapsed');

                $this.find('.settings__item-icon--expanded').removeClass('settings__item-icon--active');
                $this.find('.settings__item-icon--collapsed').addClass('settings__item-icon--active');

                $sectionBody[0].style.cssText = [
                  'opacity: 0;',
                  'height: 0px;'
                ].join('');

                setTimeout(function () {
                  $section.removeClass('section--transitioning');
                  $sectionBody[0].style.cssText = '';
                }, 375);

                $.ajax({
                  type: 'POST',
                  dataType: 'json',
                  cache: false,
                  data: {
                    form: {
                      type: 'section-settings-user',
                      referenceId: $settings.parents('.section').attr('data-reference-id'),
                      collapsed: 1
                    }
                  },
                  url: $settings.attr('data-url')
                });
              }
            }
          });
      }
    });
  }

  $(window).trigger('resize');

  if (window.positioner) {
    window.positioner.init();
  }
}

function onChangeWrapper(field, callback) {
  var reloadClass = field.attr('data-reload-start-class');

  if (typeof reloadClass !== 'undefined') {
    field.addClass(reloadClass);
  }

  var $input = field.find('input, select');

  if ($input.length > 0) {
    reloadDueTo = $input.attr('name');
  }
  else {
    var name = field.attr('name');

    if (typeof name !== 'undefined') {
      reloadDueTo = name;
    }
    else {
      reloadDueTo = '';
    }
  }

  callback();
}

function initListeners($form) {
  var $listeners = $form.find('.form-element.register-listener, button.register-listener, .sortable.register-listener, .tabs.register-listener');

  var $buttons = $form.find('.button--link');

  if ($buttons.length > 0) {
    $buttons.unbind('click.disable').bind('click.disable', function() {
      var
        $this = $(this),
        href = $this.attr('href');

      if ($this.hasClass('button--popup') || $this.hasClass('popup--trigger') || $this.hasClass('button--depricated')) {
        return;
      }

      if ($this.attr('target') !== 'undefined' && $this.attr('target') === '_blank') {
        return;
      }

      if (typeof href !== 'undefined' && (href.indexOf('->click') !== -1 || href.indexOf('void(') !== -1)) {
        return;
      }
    });
  }

  if ($listeners.length > 0) {
    $listeners.each(function () {
      var
        $thiz = $(this),
        type = $thiz.attr('data-type'),
        change = $thiz.attr('data-change'),
        confirm = $thiz.attr('data-change-confirm'),
        confirmDescription = $thiz.attr('data-change-confirm-description'),
        callback = null,
        field = null;

      if (type === 'select') {
        field = $thiz.find('select');
      }
      else if (['sortable', 'button', 'tabs'].indexOf(type) !== -1) {
        field = $thiz;
      }
      else if (type === 'textarea' || type === 'editor') {
        field = $thiz.find('textarea');
      }
      else {
        field = $thiz.find('input');
      }

      switch (change) {
        case 'save':
          switch (type) {
              case 'text':
              case 'tags':
              case 'textarea':
              case 'clockpicker':
              case 'color':
              case 'number':
              case 'editor':
              case 'mask':
              case 'media':
              case 'date':
              case 'slider':
                callback = saveForm.bind(null, field[0], true);
                break;

              case 'select':
              case 'radio':
              case 'checkbox':
              case 'switch':
              case 'button':
              case 'sortable':
              case 'tabs':
                callback = saveForm.bind(null, field[0]);
                break;
            }
          break;

        case 'reload':
            switch (type) {
              case 'text':
              case 'tags':
              case 'textarea':
              case 'clockpicker':
              case 'color':
              case 'number':
              case 'editor':
              case 'mask':
              case 'media':
              case 'date':
              case 'slider':
              case 'select':
              case 'radio':
              case 'checkbox':
              case 'switch':
              case 'button':
              case 'sortable':
              case 'tabs':
                callback = reloadForm.bind(null, field[0]);
                break;
            }
          break;

        case 'reload-all-after':
          switch (type) {
            case 'text':
            case 'tags':
            case 'textarea':
            case 'clockpicker':
            case 'color':
            case 'number':
            case 'editor':
            case 'mask':
            case 'media':
            case 'date':
            case 'slider':
            case 'select':
            case 'radio':
            case 'checkbox':
            case 'switch':
            case 'button':
            case 'sortable':
            case 'tabs':
              callback = reloadForm.bind(null, field[0], window.UI.reloadAllForms);
              break;
          }
        break;
      }

      if (callback !== null) {
        var binds = null;

        switch (type) {
          case 'text':
          case 'textarea':
          case 'number':
          case 'mask':
          case 'editor':
          case 'color':
            binds = ['change.formular', 'keyup.formular', 'input.formular', 'paste.formular'];
            callback = debounce(callback, 1000);
            break;

          case 'tags':
            binds = ['itemRemoved.formular', 'itemAdded.formular'];
            break;

          case 'tabs':
            binds = ['tabsChanged.formular'];
            break;

          case 'slider':
          case 'clockpicker':
          case 'media':
            binds = ['keyup.formular', 'change.formular'];
            callback = debounce(callback, 1000);
            break;

          case 'radio':
          case 'checkbox':
          case 'switch':
          case 'button':
            binds = ['click.formular'];

            if (typeof confirm !== 'undefined') {
              callback = function (fn) {
                if (confirmDescription && confirmDescription !== '') {
                  UI.confirm({
                    'callback_ok': function () {
                      fn();
                    },
                    'callback_cancel': function () {

                    },
                    'description': confirmDescription
                  });
                }
                else {
                  UI.confirm({
                    'callback_ok': function () {
                      fn();
                    },
                    'callback_cancel': function () {

                    }
                  });
                }
              }.bind(null, callback);
            }
            break;

          case 'sortable':
            binds = ['sort.formular'];
            break;

          case 'select':
          case 'date':
            binds = ['change.formular'];

            if (typeof confirm !== 'undefined') {
              callback = function (fn) {
                if (confirmDescription && confirmDescription !== '') {
                  UI.confirm(function () {
                    fn();
                  }, function () {

                  }, false, confirmDescription);
                }
                else {
                  UI.confirm(function () {
                    fn();
                  }, function () {

                  }, false);
                }
              }.bind(null, callback);
            }
            else {
              callback = function (fn) {
                setTimeout(function () {
                  $('body > .select2-container--open').remove();
                });
                fn();
              }.bind(null, callback);
            }
            break;
        }

        if (binds !== null) {
          callback = onChangeWrapper.bind(null, $thiz, callback);

          field.unbind(binds.join(' ')).bind(binds.join(' '), callback);
        }
      }
    });
  }
}

function initModalForm($form) {
  var selectedSection = 0;

  if (typeof $form.attr('data-active-section') !== 'undefined') {
    selectedSection = parseInt($form.attr('data-active-section'), 10);
  }

  var
    $active_section = $('#form_data-active-section_id'),
    from = selectedSection + 0,
    to = selectedSection + 0;

  if ($active_section.length > 0) {
    var activeSectionVal = $active_section.val();

    if (activeSectionVal === '' || activeSectionVal === 'first') {
      activeSectionVal = '0';
    }

    selectedSection = to = parseInt(activeSectionVal, 10);

    $form.attr('data-active-section', selectedSection);
  }

  if ($form.find('> .section').length > 1) {
    $form.addClass('form--stepguide');

    var $stepguide;

    if ($form.parent().find('.stepguide').length > 0) {
      $form.parent().find('.stepguide').remove();
    }

    //if ($form.parent().find('.stepguide').length == 0) {
      var stepsOutput = [];

      $form.find('> .section').each( function() {
        stepsOutput.push('<li class="stepguide__item" data-reference-id="' + $(this).attr('data-reference-id') + '">' + $(this).find('.section__title:first').text() + '</li>');
      });

      /*jshint multistr: true */
      $stepguide = $('<ul class="stepguide stepguide--popup">\
        ' + stepsOutput.join('') + '\
        </ul>');

      $form.before($stepguide);

      $stepguide.find('.stepguide__item').unbind('click').bind('click', function() {
        if (typeof $form.attr('data-active-section') !== 'undefined') {
          selectedSection = parseInt($form.attr('data-active-section'), 10);
        }
        else {
          selectedSection = 0;
        }

        if ($(this).index() <= selectedSection) {
          navigateToStep($stepguide, $(this).index());
        }

        return false;
      });
    /*}
    else {
      $stepguide = $form.parent().find('.stepguide');
    }*/

    var $formSection = $form.find('> .section');

    if (from === to) {
      $formSection.each( function() {
        var
          $this = $(this),
          thisIndex = $formSection.index(this);

        if (thisIndex < selectedSection) {
          $this.addClass('section--inactive');

          $stepguide.find('.stepguide__item:eq(' + thisIndex + ')').addClass('stepguide__item--visited');
        }
        else if (thisIndex == selectedSection) {
          $this.addClass('section--active');

          $stepguide.find('.stepguide__item:eq(' + thisIndex + ')').addClass('stepguide__item--current');

          if ($this.outerHeight() > 0) {
            $form.css({
              height: $this.outerHeight() + 'px'
            });
          }

          if ($this.find('img').length > 0) {
            $this.find('img').eq(0).on('load', function() {
              this.find('img').eq(0).off('load');

              if (this.outerHeight() > 0) {
                $form.css({
                  height: this.outerHeight() + 'px'
                });
              }
            }.bind($this));
          }

          /*setTimeout( function() {
            if (this.outerHeight() > 0) {
              $form.css({
                height: this.outerHeight() + 'px'
              });
            }
          }.bind($this), 500);*/
        }
      });
    }
    else {
      $formSection.each( function() {
        var
          $this = $(this),
          thisIndex = $formSection.index(this);

        if (thisIndex < from) {
          $this.addClass('section--inactive');

          $stepguide.find('.stepguide__item:eq(' + thisIndex + ')').addClass('stepguide__item--visited');
        }
        else if (thisIndex == from) {
          $this.addClass('section--active');

          $stepguide.find('.stepguide__item:eq(' + thisIndex + ')').addClass('stepguide__item--current');

          if ($this.outerHeight() > 0) {
            $form.css({
              height: $this.outerHeight() + 'px'
            });
          }
        }
      });

      setTimeout(function () {
        navigateToStep($stepguide, to);
      }, 250);
    }

    var $btnSubmit = $form.find('.form-actions .button--submit');

    if ($btnSubmit.length > 0) {
      $btnSubmit.data('original', $btnSubmit.val());

      window.Lang.translate(function (translations) {
        $btnSubmit.val(translations.next);
      }, {
        'next': 'Next'
      });
    }
  }
  else {
    $form.addClass('form--no-stepguide');
  }
}

var isReloading = false;

function reloadForm(element, callback, abortExisting) {
  loading = false;
  reload = false;

  if (element.nodeName.toLowerCase() == 'button' && isReloading) {
    return;
  }

  isReloading = true;

  if (typeof abortExisting === 'undefined') {
    abortExisting = true;
  }

  if (abortExisting && typeof window.game_form_ajax !== 'undefined' && window.game_form_ajax !== null) {
    window.game_form_ajax.abort();
    window.game_form_ajax = null;
  }

  var $element = $(element);
  var $form = $element.parents('form');

  if (element.nodeName.toLowerCase() == 'button') {
    var name = $element.attr('name');

    window.additional_params = '&' + name + '=' + $element.val();
  }
  else {
    window.additional_params = null;
  }

  if ($form.length > 0) {
    submitForm($form, true, false, callback);
  }
}

function saveForm(element, callback) {
  callback = callback || null;

  reloadDueTo = '';

  loading = false;

  if (typeof window.game_form_ajax !== 'undefined' && window.game_form_ajax !== null) {
    window.game_form_ajax.abort();
    window.game_form_ajax = null;
  }

  var $element = $(element);
  var $form = $element.parents('form');

  if ($form.length > 0) {
    submitForm($form, false, true, callback);
  }
}

function submitForm($form, reload, save, callback, abortExisting) {
  if (loading) {
    return;
  }

  reload = reload || false;
  save = save || false;
  $form = $form || null;
  callback = callback || null;

  if (typeof abortExisting === 'undefined') {
    abortExisting = true;
  }

  loading = true;

  if ($form) {
    var data;
    var $disabledFields = $form.find(':disabled');

    //UI.showLoader();

    $form.addClass('form--loading');
    $form.find('input[type=text], input[type=email], input[type=password], input[type=tel], input[type=url], input[type=number], textarea').each(function() {
      $(this).val($.trim($(this).val()));
    });

    if (document.body.classList.contains('form-iframe-api-template')) {
      window.top.postMessage(JSON.stringify({
        'type': 'frame-form-loading',
        'data': null
      }), '*');
    }

    $(document).trigger('FORM_SUBMIT', $form);

    if ($disabledFields.length > 0) {
      $disabledFields.attr('disabled', false);
    }

    $('.CodeMirror').each(function() {
      $(this)[0].CodeMirror.save();
    });

    var $settings = $form.find('.section__header > .settings input:not([disabled]), .section__header > .settings select:not([disabled])');

    if ($settings.length > 0) {
      $settings.each(function () {
        $(this).attr('disabled', 'disabled');
        $(this).addClass('remove-disabled-after-save');
      });
    }

    if ($form[0].nodeName.toLowerCase() == 'form') {
      data = $form.serialize();

      $form.find('input[type=checkbox]:not([disabled])').each(function() {
        if (!this.checked) {
          data += '&'+this.name+'=0';
        }
      });
    }
    else {
      var
        r20 = /%20/g,
        rbracket = /\[\]$/,
        rCRLF = /\r?\n/g,
        rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
        rsubmittable = /^(?:input|select|textarea|keygen)/i,
        rcheckableType = ( /^(?:checkbox|radio)$/i );

      data = $.param(
        $form.find('input,textarea,select').filter(function() {
          var type = this.type;

          // Use .is(":disabled") so that fieldset[disabled] works
          return this.name && !$(this).is( ":disabled" ) &&
            rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
            (this.checked || !rcheckableType.test(type));
        })
        .map(function(i, elem) {
          var val = $(this).val();

          return val === null ?
            null :
            $.isArray(val) ?
              $.map(val, function(val) {
                return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
              }) :
              { name: elem.name, value: val.replace(rCRLF, "\r\n") };
        }).get());
    }

    data += '&ajax=true';

    if (reload) {
      data += '&reload=true';
    }

    data += '&active_section=' + (typeof $form.attr('data-active-section') !== 'undefined' ? $form.attr('data-active-section') : '0');

    if (typeof window.additional_params !== 'undefined' && window.additional_params !== null) {
      data += window.additional_params;
    }

    if (reload) {
      data += '&form[reload_due_to]=' + reloadDueTo;
    }

    window.additional_params = null;

    if ($disabledFields.length > 0) {
      $disabledFields.attr('disabled', true);
    }

    navMapping = [];

    $('.form .tab-navigation').each(function () {
      var $li = $(this).find('.tab-navigation__item--active');

      data += '&form[' + $li.data('name') + ']=1';

      navMapping.push({
        index: $li.index(),
      });
    });

    scrollMapping = [];

    $('.form .remember-scroll').each(function () {
      scrollMapping.push({
        scroll: this.scrollTop,
        name: $(this).attr('data-instance-name'),
      });
    });

    if (document.activeElement !== null && typeof document.activeElement.nodeName !== 'undefined' && ['textarea', 'input'].indexOf(document.activeElement.nodeName.toLowerCase()) !== -1) {
      try {
        caretMapping.caretAtPosition = getCaretPosition(document.activeElement);
        caretMapping.elemId = document.activeElement.id;
      }
      catch (e) {
        caretMapping.caretAtPosition = null;
        caretMapping.elemId = null;
      }
    }
    else {
      caretMapping.caretAtPosition = null;
      caretMapping.elemId = null;
    }

    $form.find('.remove-disabled-after-save').each(function () {
      $(this).removeClass('remove-disabled-after-save');
      $(this).removeAttr('disabled');
    });

    window.last_game_form_element = $form;
    window.last_game_form_ajax_url = (reload ? $form.attr('data-update') : $form.attr('data-save'));
    window.last_game_form_ajax_data = data;
    window.last_game_form_reload = reload;
    window.last_game_form_save = save;

    if (abortExisting && typeof window.game_form_ajax !== 'undefined' && window.game_form_ajax !== null) {
      window.game_form_ajax.abort();
      window.game_form_ajax = null;
    }

    window.game_form_ajax = $.ajax({
      url: window.last_game_form_ajax_url,
      dataType: 'json',
      method: 'POST',
      type: 'POST',
      data: data,
      success: function(data) {
        isReloading = false;
        formular_handle_response(data, $form, save, reload, callback);
      }
    });
  }
}

function formular_handle_response(data, $form, save, reload, callback) {
  callback = callback || null;

  if (reload) {
    domRememberMapping = {};
    domRememberMappingContainer = document.createDocumentFragment();

    $form.find('.remember-dom').each(function () {
      domRememberMapping[this.getAttribute('data-instance-name')] = this;
      domRememberMappingContainer.appendChild(
        this
      );
    });
  }

  $form.removeClass('form--loading');

  //UI.hideLoader();

  /*if (typeof window.top.UI !== 'undefined') {
    window.top.UI.processAjax(data, $form);
  }
  else if (typeof window.UI !== 'undefined') {
    window.UI.processAjax(data, $form);
  }*/

  window.UI.processAjax(data, $form);

  loading = false;

  if (save) {
    if (document.body.classList.contains('form-iframe-api-template')) {
      window.UI.setFormIframeApiHeight();

      window.top.postMessage(JSON.stringify({
        'type': 'frame-form-reload',
        'data': null
      }), '*');

      if (typeof data.error !== 'undefined' && typeof data.error.message !== 'undefined') {
        UI.error(data.error.message, data.error.title, $form);
      }
    }

    if (callback !== null && callback !== true) {
      callback();
    }
  }
  else if (reload) {
    var $elements = $('<div />').append($(data.data)).hide().appendTo(document.body);

    if (jQuery().clockpicker) {
      var $clockpicker = $form.find('.form-element__input--clockpicker');

      $clockpicker.each(function () {
        var $this = $(this);

        $this.clockpicker('remove');
      });
    }

    if (typeof $.fn.datepicker !== 'undefined') {
      $form.find('.datepicker').datepicker('destroy');
    }

    $form.find('.html5editor.init').each(function () {
      $(this).wysihtml5('destroy');
    });

    $form.addClass('form--init');

    $('.colorpicker, .colorpicker-old, .datepicker-dropdown, body > .select2-container--open').remove();

    initFormElements($elements);

    UI.init();

    initListeners($elements);

    $elements.show();

    var frag = document.createDocumentFragment();

    while ($elements[0].childNodes.length > 0) {
      frag.appendChild($elements[0].childNodes[0]);
    }

    $form.html('');
    $form[0].appendChild(frag);

    if ($('body').hasClass('page--popup') && $form.find('.section').length > 0 && !$form.hasClass('form--no-stepguide')) {
      initModalForm($form);
    }

    if (typeof window.formReloadTrigger !== 'undefined') {
      window.formReloadTrigger();
    }

    if (document.body.classList.contains('form-iframe-api-template')) {
      window.UI.setFormIframeApiHeight();

      window.top.postMessage(JSON.stringify({
        'type': 'frame-form-reload',
        'data': null
      }), '*');
    }

    $(window).trigger('FORM_INIT');

    setTimeout(function() {
      $form.removeClass('form--init');

      $(document).trigger('FORM_RELOAD', $form);

      if (caretMapping.elemId !== null && caretMapping.elemId !== '' && caretMapping.caretAtPosition !== null) {
        setCaretPosition(
          $form.find('#' + caretMapping.elemId)[0],
          caretMapping.caretAtPosition.start,
          caretMapping.caretAtPosition.end
        );
      }

      $form.find('.form-element[data-reload-start-class]').each(function () {
        var $thiz = $(this);

        $thiz.removeClass($thiz.attr('data-reload-start-class'));
      });

      if (callback !== null) {
        callback();
      }
    });
  }
  else {
    if (document.body.classList.contains('form-iframe-api-template')) {
      window.UI.setFormIframeApiHeight();

      window.top.postMessage(JSON.stringify({
        'type': 'frame-form-reload',
        'data': null
      }), '*');
    }

    if (callback !== null) {
      callback();
    }
  }

  window.game_form_ajax = null;
}

function showSuccess($form, redirect) {
  var $formSuccess = $form.find('.message--success');

  redirect = redirect || false;

  if (!$formSuccess.hasClass('message--active')) {
    $formSuccess.addClass('message--active');
  }

  if (redirect) {
    $formSuccess.addClass('message--redirect');
  }
  else {
    $formSuccess.removeClass('message--redirect');
  }

  $formSuccess.find('.close').unbind('click').bind('click', function (e) {
    $(this).parent().removeClass('message--active');

    return false;
  });
}

window.showSuccess = showSuccess;

function hideSuccess($form) {
  var $formSuccess = $form.find('.message--success');

  if ($formSuccess.hasClass('message--active')) {
    $formSuccess.removeClass('message--active');
  }
}

function navigateToStep($stepguide, index) {
  var $currentForm = $stepguide.siblings('.form');
  $currentForm.attr('data-active-section', index);

  var $hidden = $currentForm.find('#form_data-active-section_id');

  if ($hidden.length > 0) {
    $hidden.val(index);
  }

  $('html, body').animate({ scrollTop: '0px' }, ($(document.body).scrollTop() > 0 ? 100 : 0), function () {
    $stepguide.find('.stepguide__item').each( function() {
      var $this = $(this);

      if ($this.index() < index) {
        $this.removeClass('stepguide__item--current').addClass('stepguide__item--visited');
        $currentForm.find('> .section:eq(' + $this.index() + ')').removeClass('section--active').addClass('section--inactive');
      }
      else if ($this.index() == index) {
        $this.removeClass('stepguide__item--visited').addClass('stepguide__item--current');
        $currentForm.find('> .section:eq(' + $this.index() + ')').removeClass('section--inactive').addClass('section--active');

        if ($currentForm.find('.section:eq(' + $this.index() + ')').outerHeight() > 0) {
          $currentForm.css({
            height: $currentForm.find('.section:eq(' + $this.index() + ')').outerHeight() + 'px'
          });
        }
      }
      else {
        $this.removeClass('stepguide__item--current').removeClass('stepguide__item--visited');
        $currentForm.find('> .section:eq(' + $this.index() + ')').removeClass('section--active').removeClass('section--inactive');
      }
    });
  });
}

function registerTypeahead($field) {
  var $controls = $field.find('.form-element__controls');
  var $text = $controls.find('input[type="text"]');
  var $ajax = null;

  $text.after([
    '<div class="form-element__typeahead">',
      '<ul class="form-element__typeahead-list">',
      '</ul>',
    '</div>'
  ].join(''));

  var $typeahead = $controls.find('.form-element__typeahead');
  var $typeaheadList = $controls.find('.form-element__typeahead-list');

  $text.before('<input type="hidden" name="' + $text.attr('name') + '" value="" />');

  var $hidden = $text.parent().find('input[type="hidden"]');

  $text.removeAttr('name');

  $text.unbind('keypress keydown keyup focus').bind('keypress keydown keyup focus', debounce(function () {
    var startTime = new Date().getTime();

    if ($ajax !== null) {
      $ajax.abort();
      $ajax = null;
    }

    $ajax = $.ajax({
      type: 'POST',
      dataType: 'json',
      data: {
        value: $text.val(),
        reload: 1
      },
      url: $text.attr('data-endpoint'),
      success: function (data) {
        if (typeof data.result !== 'undefined') {
          var html = '';

          for (var resultItem in data.result) {
            html += [
              '<li class="form-element__typeahead-list-item" data-id="' + data.result[resultItem].id + '">',
                '<b>' + data.result[resultItem].title + '</b>',
                (typeof data.result[resultItem].description !== 'undefined' ? '<span>' + data.result[resultItem].description + '</span>' : ''),
              '</li>'
            ].join('');
          }

          $typeaheadList.html(html);

          $typeaheadList.find('.form-element__typeahead-list-item').unbind('click').bind('click', function () {
            $hidden.val($(this).attr('data-id'));

            $text.val('').unbind('keypress keydown keyup focus').attr('disabled', 'disabled');

            $typeahead.remove();

            reloadForm($text[0]);
          });
        }
        else {
          $typeaheadList.html('');
        }
      }
    });
  }, 250));
}

function registerSortable($sortable) {
  $sortable.find('> .form-element--sortable').each(function () {
    var $this = $(this);
    var reference = $this.attr('data-reference');
    var $reference = (typeof reference !== 'undefined' ? $this.find(reference) : $this);

    $this.unbind('mousedown').bind('mousedown', function (e) {
      if (e.which !== 3 && $this.parents('.form--loading').length === 0 && !$(e.target).hasClass('form-element__input')) {
        e.preventDefault();

        var itemOffset = null;
        var relativeX = 0;
        var relativeY = 0;
        var $placeholder = null;


        var itemWidth = null;
        var itemHeight = null;

        var left = 0;
        var top = 0;

        var lastKnownX = e.pageX;
        var lastKnownY = e.pageY;

        var firstMove = true;

        $(document)
          .bind('mousemove.sortable', function (evt) {
            var diffX = Math.abs(evt.pageX - e.pageX);
            var diffY = Math.abs(evt.pageY - e.pageY);

            if (firstMove && (diffX >= 10 || diffY >= 10)) {
              $(document.body).addClass('sortable-is-sorting');

              $placeholder = $('<span class="form-element form-element--sortable-placeholder" />');

              $placeholder.css({
                width: $reference.outerWidth(),
                height: $reference.outerHeight(),
                marginTop: $this.css('margin-top'),
                marginBottom: $this.css('margin-bottom')
              });

              $this.after($placeholder);

              $this.css({
                width: $this.outerWidth(),
                height: $this.outerHeight()
              });

              itemOffset = $reference[0].getBoundingClientRect();

              relativeX = (evt.pageX - window.pageXOffset) - itemOffset.left;
              relativeY = (evt.pageY - window.pageYOffset) - itemOffset.top;

              itemWidth = $reference.outerWidth();
              itemHeight = $reference.outerHeight();

              left = ((evt.pageX - window.pageXOffset) - relativeX);
              top = ((evt.pageY - window.pageYOffset) - relativeY);

              if (left < 0) {
                left = 0;
              }
              else if ((left + itemWidth) > window.innerWidth) {
                left = window.innerWidth - itemWidth;
              }

              if (top < 0) {
                top = 0;
              }
              else if ((top + itemHeight) > window.innerHeight) {
                top = window.innerHeight - itemHeight;
              }

              $this.css({
                left: left + 'px',
                top: top + 'px',
                userSelect: 'none',
                pointerEvents: 'none'
              });

              $this.addClass('form-element--sortable-is-sorting');

              firstMove = false;

              $(window)
                .unbind('scroll.sortable')
                .bind('scroll.sortable', function (e2) {
                  setTimeout(function () {
                    left = ((lastKnownX - relativeX));
                    top = ((lastKnownY - relativeY));

                    if (left < 0) {
                      left = 0;
                    }
                    else if ((left + itemWidth) > window.innerWidth) {
                      left = window.innerWidth - itemWidth;
                    }

                    if (top < 0) {
                      top = 0;
                    }
                    else if ((top + itemHeight) > window.innerHeight) {
                      top = window.innerHeight - itemHeight;
                    }

                    $this[0].style.left = left + 'px';
                    $this[0].style.top = top + 'px';

                    testPoint(lastKnownX, lastKnownY, $this, $placeholder);
                  }, 1);
                });
            }

            if (!firstMove) {
              evt.preventDefault();

              left = ((evt.pageX - window.pageXOffset) - relativeX);
              top = ((evt.pageY - window.pageYOffset) - relativeY);

              if (left < 0) {
                left = 0;
              }
              else if ((left + itemWidth) > window.innerWidth) {
                left = window.innerWidth - itemWidth;
              }

              if (top < 0) {
                top = 0;
              }
              else if ((top + itemHeight) > window.innerHeight) {
                top = window.innerHeight - itemHeight;
              }

              $this[0].style.left = left + 'px';
              $this[0].style.top = top + 'px';

              testPoint((evt.pageX - window.pageXOffset), (evt.pageY - window.pageYOffset), $this, $placeholder);

              lastKnownX = (evt.pageX - window.pageXOffset);
              lastKnownY = (evt.pageY - window.pageYOffset);
            }
          })
          .bind('mouseup.sortable', function (evt) {
            $(window).unbind('scroll.sortable');

            $(document.body).removeClass('sortable-is-sorting');

            evt.preventDefault();

            if ($placeholder !== null) {
              $placeholder.remove();
            }

            $reference[0].style.cssText = '';
            $this[0].style.cssText = '';
            $this.removeClass('form-element--sortable-is-sorting');

            $(document).unbind('mousemove.sortable mouseup.sortable');

            var diffX = Math.abs(lastKnownX - (e.pageX - window.pageXOffset));
            var diffY = Math.abs(lastKnownY - (e.pageY - window.pageYOffset));

            if (diffX >= 5 || diffY >= 5) {
              $this.trigger('sort');
            }
          });
      }
    });
  });
}

function testPoint(x, y, $element, $placeholder) {
    var offset;

    $element[0].style.display = 'none';
    offset = $element[0].offsetWidth;

    var target = document.elementFromPoint(x, y);

    $element[0].style.display = 'block';
    offset = $element[0].offsetWidth;

    var $target = $(target);

    if (!$target.hasClass('form-element--sortable')) {
      $target = $target.parents('.form-element--sortable');
    }

    if ($target.length > 0 && $target.hasClass('form-element--sortable')) {
      var $placeholderFrom = $('<div />');
      var $placeholderTo = $('<div />');

      $placeholder.after($placeholderFrom);
      $target.after($placeholderTo);

      $placeholderTo.replaceWith($element);
      $element.after($placeholder);

      $placeholderFrom.replaceWith($target);

      $placeholderFrom = null;
      $placeholderTo = null;

      return true;
    }

    $target = null;

    return false;
  }

window.formular_generic_confirm_ok = function () {
  var confirmLoading = (typeof window.game_form_confirm_loading !== 'undefined' ? window.game_form_confirm_loading : false);

  if (!confirmLoading) {
    window.game_form_confirm_loading = true;

    window.last_game_form_ajax_data += '&confirmed=1';
    window.game_form_ajax = $.ajax({
      type: 'POST',
      dataType: 'json',
      data: window.last_game_form_ajax_data,
      url: window.last_game_form_ajax_url,
      success: function(data) {
        formular_handle_response(data, window.last_game_form_element, window.last_game_form_save, window.last_game_form_reload);

        game_form_confirm_loading = false;
      }
    });
  }
};

window.formular_generic_confirm_cancel = function () {
};

$(document).ready(function () {
  if ($('form.form').length > 0) {
    window.initForm();
  }
});


$(window).bind('message', function (e) {
  if (e.originalEvent.data === 'form-reload-all') {
    window.UI.reloadAllInstances();
  }
});
